import React from "react";
import Layout from "../../../components/layout/Layout";
import { ArrayUtil, DateUtil, isAlive, isFillAlive } from "../../../util/";
import i18n from "../../../i18n/";
import { ContainerLoading, PreloadDiv } from "../../../components/loading/PersistGateLoading";
import ReportAction from "../../../actions/ReportAction";
import { StressTestSupportGraph } from "../../../constants/supportGraph";
import { StressGeneric } from "./index";

export default (props)=><StressGeneric 
	typeKey={StressTestSupportGraph.Gender}
	subHeader={i18n.t("gender")}
	fetchMain={ReportAction.fetchStressGender}
	getAutoSelectItem={(items)=>{
		const key = Object.keys(items).filter(k=>items[k]>0);
		if(isFillAlive(key)){
			return key[0];
		}
		return undefined;
	}}
/>;


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Stress/StressByGender.js